// extracted by mini-css-extract-plugin
export default {"content":"PokeHeader_content__m3WL1","title":"PokeHeader_title__ONjpp"};